import ImportOrderPage from "./ImportOrderPage";

/** Trang Nhập hàng — single page: user chọn loại hàng trong form khi tạo đơn. */
export default function ImportVnPage() {
  return <ImportOrderPage />;
}
